<template>
    <div id="footer">
        <router-link id="footer-logo" tag="div" :to="{ name: 'Home' }">
            <router-link tag="img" :to="{ name: 'Home' }"
                         :src="'https://elitecrafthomes.com/static_files/images/logo-footer.png'"></router-link>
        </router-link>

        <div id="footer-links">
            <router-link :to="{ name: 'Communities' }">Communities</router-link>
            <router-link :to="{ name: 'Plans' }">Plans</router-link>
            <router-link :to="{ name: 'About' }">About</router-link>
            <router-link :to="{ name: 'Contact' }">Contact</router-link>
            <!--<router-link :to="{ name: 'Client' }">Client Login</router-link>-->
        </div>

        <div id="footer-social-media">
            <a href="https://www.facebook.com/elitecrafthomes/" target="_blank"><v-icon large color="white">
                fab fa-facebook</v-icon></a>
            <a href="https://www.instagram.com/explore/locations/112420495450217/elite-craft-homes/">
                <v-icon large color="white">fab fa-instagram</v-icon></a>
            <!--<a href="https://twitter.com"><v-icon large color="white">fab fa-youtube</v-icon></a>-->
        </div>

        <div id="footer-copyright-extras">
            <div id="copyright">
                <span>&copy; {{ date }} Elite Craft Homes. All Rights Reserved</span>
                <span id="copyright-extras-spacer">|</span>
            </div>

            <div id="extras">
                <router-link :to="{ name: 'Site' }">Site Map</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        computed: {
            date() {
                return new Date().getFullYear();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @media screen and (max-width: 450px) {
        #footer {
            background-color: #625856;
            height: 312px;
            position: relative;

            #footer-logo {
                position: absolute;
                left: 50%;
                top: 50px;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                background-color: #625856;
                img {
                    width: 60px;
                    max-width: 60px;
                    height: 40px;
                    max-height: 40px;
                    /*object-fit: fill;*/
                    cursor: pointer;
                    -webkit-transform: scaleX(1.5);
                    -moz-transform: scaleX(1.5);
                    -ms-transform: scaleX(1.5);
                    -o-transform: scaleX(1.5);
                    transform: scaleX(1.5);
                    /*text-align: center;*/
                }
            }

            #footer-links {
                position: absolute;
                top: 100px;
                width: 100%;
                padding: 0 15px;
                text-align: center;
                a {
                    font-weight: bold;
                    font-size: 14px;
                    color: white;
                    display: inline-block;
                    text-decoration: none;
                    padding: 0 5px;
                    text-align: center;
                }
            }

            #footer-social-media {
                top: 140px;
                width: 100%;
                position: absolute;
                text-align: center;
                padding: 0 15px;
                a {
                    padding: 0 12px;
                    color: white;
                    text-decoration: none;
                    i {
                        color: white;
                    }
                }
            }

            #copyright {
                position: absolute;
                top: 200px;
                width: 100%;
                text-align: center;
                span {
                    color: white;
                    font-size: 14px;
                }
            }

            #copyright-extras-spacer {
                display: none;
            }

            #extras {
                position: absolute;
                top: 240px;
                width: 100%;
                text-align: center;
                a {
                    font-size: 14px;
                    color: white;
                    text-decoration: none;
                }
                span:nth-of-type(1) {
                    padding: 0 10px;
                    font-size: 22px;
                    color: white;
                }
                span:nth-of-type(2) {
                    padding: 0 10px;
                    font-size: 20px;
                    color: white;
                }

            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        #footer {
            background-color: #625856;
            height: 325px;
            max-height: 325px;
            position: relative;

            #footer-logo {
                position: absolute;
                left: 50%;
                top: 50px;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                img {
                    width: 100px;
                    max-width: 100px;
                    height: 40px;
                    max-height: 40px;
                    object-fit: fill;
                    cursor: pointer;
                }
            }

            #footer-links {
                position: absolute;
                top: 100px;
                width: 100%;
                padding: 0 15px;
                text-align: center;
                a {
                    font-weight: bold;
                    font-size: 14px;
                    color: white;
                    display: inline-block;
                    text-decoration: none;
                    padding: 0 5px;
                    text-align: center;
                }
            }

            #footer-social-media {
                top: 140px;
                width: 100%;
                position: absolute;
                text-align: center;
                padding: 0 15px;
                a {
                    padding: 0 12px;
                    color: white;
                    text-decoration: none;
                    i {
                        color: white;
                    }
                }
            }


            #copyright {
                position: absolute;
                top: 200px;
                width: 100%;
                text-align: center;
                span {
                    color: white;
                    font-size: 14px;
                }
            }

            #copyright-extras-spacer {
                display: none;
            }

            #extras {
                position: absolute;
                top: 240px;
                width: 100%;
                text-align: center;
                a {
                    font-size: 14px;
                    color: white;
                    text-decoration: none;
                }
                span:nth-of-type(1) {
                    padding: 0 10px;
                    font-size: 22px;
                    color: white;
                }
                span:nth-of-type(2) {
                    padding: 0 10px;
                    font-size: 20px;
                    color: white;
                }

            }
        }
    }

    @media screen and (min-width: 1025px) {
        #footer {
            background-color: #625856;
            height: 325px;
            max-height: 325px;
            position: relative;
            #footer-logo {
                max-width: 1200px;
                width: 100%;
                position: absolute;
                text-align: center;
                top: 50px;
                left: 50%;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                img {
                    max-width: 140px;
                    width: 140px;
                    max-height: 60px;
                    height: 60px;
                    object-fit: fill;
                    cursor: pointer;
                    text-align: center;
                }
            }

            #footer-links {
                position: absolute;
                top: 125px;
                width: 100%;
                text-align: center;
                max-width: 1200px;
                left: 50%;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                a {
                    font-weight: bold;
                    font-size: 20px;
                    color: white;
                    display: inline-block;
                    text-decoration: none;
                    padding: 0 10px;
                    text-align: center;
                }
            }

            #footer-social-media {
                position: absolute;
                top: 185px;
                width: 100%;
                max-width: 1200px;
                text-align: center;
                left: 50%;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                a {
                    padding: 0 15px;
                    color: white;
                    text-decoration: none;
                    i {
                        color: white;
                    }
                }
            }

            #footer-copyright-extras {
                max-width: 1200px;
                width: 100%;
                text-align: center;
                bottom: 35px;
                position: absolute;
                left: 50%;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                #copyright {
                    position: relative;
                    display: inline-block;
                    span {
                        color: white;
                        font-size: 16px;
                    }
                    #copyright-extras-spacer {
                        padding: 0 10px;
                        font-size: 20px;
                        color: white;
                    }
                }

                #extras {
                    position: relative;
                    display: inline-block;
                    a {
                        font-size: 16px;
                        color: white;
                        text-decoration: none;
                    }
                    span:nth-of-type(1) {
                        padding: 0 10px;
                        font-size: 22px;
                        color: white;
                    }
                    span:nth-of-type(2) {
                        padding: 0 10px;
                        font-size: 20px;
                        color: white;
                    }

                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue